import { Button, Flex } from '@chakra-ui/react';
import { useState } from 'react';

import Dialog from '@app/components/common/modals/dialog';
import { Txt } from '@app/components/common';

import { ActionDialogProps } from './types';

export const WaitDialog = ({ onAction, selectedTx, actionName }: ActionDialogProps) => {
  const [open, setOpen] = useState(false);
  return <>
    <Button colorScheme='brand' onClick={() => setOpen(true)} >{actionName}</Button>
    <Dialog
      open={open}
      title="Ожидание"
      onClose={() => setOpen(false)}
      actions={[
        <Button variant='solid' colorScheme='brand' key='cancel' onClick={() => {
          onAction(selectedTx);
          setOpen(false);
        }}>Подтвердить</Button>
      ]}
    >
      <Flex>
        <Txt>Перевести перемещение ХО в ожидание?</Txt>
      </Flex>
    </Dialog>
  </>;
};